/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiActiveAlertNoteTemplate
 */
export interface InternalApiActiveAlertNoteTemplate {
    /**
     * 
     * @type {string}
     * @memberof InternalApiActiveAlertNoteTemplate
     */
    handle: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiActiveAlertNoteTemplate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiActiveAlertNoteTemplate
     */
    content: string;
}

/**
 * Check if a given object implements the InternalApiActiveAlertNoteTemplate interface.
 */
export function instanceOfInternalApiActiveAlertNoteTemplate(value: object): value is InternalApiActiveAlertNoteTemplate {
    if (!('handle' in value) || value['handle'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiActiveAlertNoteTemplateFromJSON(json: any): InternalApiActiveAlertNoteTemplate {
    return InternalApiActiveAlertNoteTemplateFromJSONTyped(json, false);
}

export function InternalApiActiveAlertNoteTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiActiveAlertNoteTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'handle': json['handle'],
        'name': json['name'],
        'content': json['content'],
    };
}

export function InternalApiActiveAlertNoteTemplateToJSON(json: any): InternalApiActiveAlertNoteTemplate {
    return InternalApiActiveAlertNoteTemplateToJSONTyped(json, false);
}

export function InternalApiActiveAlertNoteTemplateToJSONTyped(value?: InternalApiActiveAlertNoteTemplate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'handle': value['handle'],
        'name': value['name'],
        'content': value['content'],
    };
}

